import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import { Toaster } from "./components/ui/sonner";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary selection:bg-brand-primary selection:text-black">
      <Navbar />
      <Hero />
      <Services />
      <CaseStudies />
      <Testimonials />
      <Contact />
      <Blog />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App dark">
      <div className="scanline" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
